export default "__VITE_ASSET__DG7aIq7v__"